module.exports = __webpack_public_path__ + "img/antes_despues_336.ee451a44.png";